import React from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";
import { useGoogleLogin } from "@react-oauth/google";

import { Cancel } from "../../../components/Form";
import Icon from "../../../icon";

import messages from "../messages";

const GoogleButton = ({ isInProgress, inProgressGoogle, googleLoginSuccess, googleLoginFailure }) => {
    const handleLoginWithGoogle = useGoogleLogin({
        onSuccess: googleLoginSuccess,
        onError: googleLoginFailure,
    });
    return (
        <Cancel google onClick={handleLoginWithGoogle} disabled={isInProgress}>
            <span className={cn("button-google", "button-google--dark")}>
                <Icon i="google" />
            </span>
            {inProgressGoogle ? (
                <FormattedMessage {...messages.googleConnecting} />
            ) : (
                <FormattedMessage {...messages.continueWithGoogle} />
            )}
        </Cancel>
    );
};

export default GoogleButton;
